export const roller = [
  "Kişisel",
  "Baba",
  "Anne",
  "Çocuk",
  "Amca",
  "Hala",
  "Teyze",
  "Dayı",
  "Dede",
  "Nene",
  "Diğer",
];

export const aileYetkileri = ["Aile Yöneticisi", "Aile Üyesi"];

export const cinsiyetler = ["Kadın", "Erkek", "Belirtmek istemiyorum"];

export const birimler = ["adet", "kg", "lt", "paket"];

export const varsayilanAlisverisKategorileri = [
  "Tümü",
  "Market",
  "Manav",
  "Kasap",
  "Şarküteri",
  "Fırın",
  "Temizlik",
  "Mutfak",
  "İçecek",
  "Kahvaltılık",
  "Atıştırmalık",
  "Kişisel Bakım",
  "Bebek",
  "Evcil Hayvan",
  "Elektronik",
  "Eczane",
  "Giyim",
  "Ev İhtiyaçları",
  "Diğer",
];

export const gelirKategorileri = [
  "Maaş",
  "Ek Gelir",
  "Serbest İş",
  "Satış",
  "Prim",
  "Kira Geliri",
  "Yatırım Getirisi",
  "Devlet Ödemesi",
  "Harçlık",
  "İade",
  "Birikimden Aktarma",
  "Diğer Gelir",
];

export const giderKategorileri = [
  "Market",
  "Fatura",
  "Kira",
  "Su",
  "Elektrik",
  "Doğalgaz",
  "İnternet",
  "Telefon",
  "Araç Gideri",
  "Yakıt",
  "Araç Bakım",
  "Otopark",
  "Sigorta",
  "Vergi",
  "Ulaşım",
  "Toplu Taşıma",
  "Çocuk",
  "Eğitim",
  "Okul",
  "Oyuncak",
  "Bebek İhtiyaçları",
  "Sağlık",
  "İlaç",
  "Hastane",
  "Muayene",
  "Giyim",
  "Ev İhtiyaçları",
  "Mobilya",
  "Temizlik",
  "Kozmetik",
  "Kafe & Restoran",
  "Yemek",
  "Eğlence",
  "Tatil",
  "Hediye",
  "Abonelik",
  "Dijital Servisler",
  "Oyun",
  "Yazılım",
  "Kredi",
  "Kredi Kartı",
  "Borç Ödemesi",
  "Yatırım",
  "Birikim",
  "Aidat",
  "Diğer Gider",
];

// Ortak harcamalar finans giderleriyle aynı kategorileri kullanır.
export const harcamaKategorileri = giderKategorileri;

export const takvimKategorileri = [
  "Aile Etkinliği",
  "Randevu",
  "Sağlık",
  "İş / Toplantı",
  "Okul / Çocuk",
  "Eğitim / Kurs",
  "Fatura / Ödeme",
  "Alışveriş",
  "Ev İşleri",
  "Sosyal Buluşma",
  "Spor / Aktivite",
  "Seyahat",
  "Tatil",
  "Resmi İş",
  "Araç",
  "Doğum Günü",
  "Kutlama",
  "Önemli",
  "Diğer",
];

export const takvimRenkleri = [
  "#2563eb",
  "#16a34a",
  "#dc2626",
  "#9333ea",
  "#f59e0b",
  "#0891b2",
  "#db2777",
  "#475569",
];

export const rolSiralamasi = [
  "Kişisel", "Baba", "Anne", "Çocuk", "Amca", "Hala", "Teyze", "Dayı", "Dede", "Nene", "Diğer"
];

export const uyelerSirala = (uyeler) => {
  return [...uyeler].sort((a, b) => {
    const aIdx = rolSiralamasi.indexOf(a.rol);
    const bIdx = rolSiralamasi.indexOf(b.rol);
    const aS = aIdx === -1 ? 99 : aIdx;
    const bS = bIdx === -1 ? 99 : bIdx;
    return aS - bS;
  });
};
